import { render, staticRenderFns } from "./ConfigurationCate.vue?vue&type=template&id=1aa5cdd1&scoped=true"
import script from "./ConfigurationCate.vue?vue&type=script&lang=js"
export * from "./ConfigurationCate.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationCate.vue?vue&type=style&index=0&id=1aa5cdd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5cdd1",
  null
  
)

export default component.exports